import React, { useEffect, useState } from "react";
import { Fade } from "react-bootstrap";

export const DelayedRender = ({ children }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const timer = window.setTimeout(() => setShow(true), 500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <Fade in={show} timeout={1500}>
        {children}
      </Fade>
    </>
  );
};
